export default __webpack_public_path__ + "static/media/redirectArrow.63493755.svg";